import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import { Col, Row } from 'react-bootstrap';
import Truncate from 'src/components/truncate';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { localizedStrings } from "../../../../../localization/index"
import Tooltip from 'src/components/tooltip';

class ContactListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }
  render() {
    return (
      <div onClick={() => this.props.showDetail(_.get(this.props.item, 'contact'))} className={cx(styles.item, entityStyles.contact, this.props.className)}>
        <img className={cx(styles.icon, entityStyles.icon)} src={DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{formatName(_.get(this.props.item, 'contact'))}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views')} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            <li>{_.get(this.props.item, 'analytics.shares')} {this.localizedTabsCommons.reshares}</li>
          </ul>
        </div>
      </div>
    );
  }
}

class ContactGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <div onClick={() => this.props.showDetail(_.get(this.props.item, 'contact'))} className={cx(styles.item, entityStyles.contact, this.props.className)}>
            <img className={cx(styles.icon, entityStyles.icon)} src={DefaultAssetIcon} />
            <div className={styles.topViewersTitle}>
              <h5 className={styles.title}>
                {formatName(_.get(this.props.item, 'contact'))}
              </h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.created}: {dateformat(_.get(this.props.item, 'contact.createdDate'), 'dd mmm yyyy')} | {_.get(this.props.item, 'contact.company')}</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views')}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.shares')}</Col>
      </Row>
    );
  }
}

//Accounts
class AccountListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const company = _.get(this.props.item, 'company') || " ";
    return (
      <div href="#" className={cx(styles.item, entityStyles.account, this.props.className)}>
        <div className={cx(styles.icon, entityStyles.icon)}>{company[0].toUpperCase()}</div>
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{company}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.users')} {this.localizedTabsCommons.users}</li>
            <li>{_.get(this.props.item, 'analytics.views')} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
          </ul>
        </div>
      </div>
    );
  }
}

class AccountGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const company = _.get(this.props.item, 'company') || " ";
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <div href="#" className={cx(styles.item, entityStyles.account, this.props.className)}>
            <div className={cx(styles.icon, entityStyles.icon)}>{company[0].toUpperCase()}</div>
            <div>
              <h5 className={styles.title}>{company}</h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.users}: {_.get(this.props.item, 'analytics.users')}</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views')}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.shares')}</Col>
      </Row>
    );
  }
}

class LeadGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    var asset = _.get(this.props.item, 'asset');
    return (
      <Row className={cx(styles.row, entityStyles.deal)}>
        <Col className={cx(styles.column, entityStyles.name)} md={4}>
          <div onClick={() => this.props.showDetail(this.props.item)} className={cx(styles.item, entityStyles.contact, this.props.className)}>
            <img className={cx(styles.icon, entityStyles.icon)} src={DefaultAssetIcon} />
            <div>
              <h5 className={styles.title}>
                {formatName(this.props.item)}
              </h5>
              <ul className={styles.metrics}>
                <li>{_.get(this.props.item, 'email')}</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{dateformat(this.props.item.createdDate, 'dd mmm yyyy')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{this.props.item.company}</Col>
        <Col className={cx(styles.column)} md={4}>
          {asset ?
            <a href={`/assets/${asset.id}`} target='_blank' className={cx(styles.item, entityStyles.asset)}>
              <img className={styles.icon} src={_.get(asset, 'icon.thumbnail') || DefaultAssetIcon} />
              <div>

                <Tooltip content={_.get(asset, 'name')} placement="bottom">
                  <Truncate width={180}  >
                    {_.get(asset, 'name')}
                  </Truncate>
                </Tooltip>

                {asset.count > 1 &&
                  <div>&amp; {asset.count - 1} {this.localizedTabsCommons.assets}</div>
                }
              </div>
            </a>
            : "--/--"}
        </Col>
      </Row>
    );
  }
}


const Contact = {
  List: ContactListItem,
  Grid: ContactGridItem,
  Account: {
    List: AccountListItem,
    Grid: AccountGridItem
  },
  Lead: {
    Grid: LeadGridItem
  }
};

export default Contact;